import { CALL_API, Schemas } from '../../common/middleware/api';
import moment from 'moment';

export const CHILDREN_REQUEST = 'CHILDREN_REQUEST';
export const CHILDREN_SUCCESS = 'CHILDREN_SUCCESS';
export const CHILDREN_FAILURE = 'CHILDREN_FAILURE';

export const CHILDREN_UNPAGED_REQUEST = 'CHILDREN_UNPAGED_REQUEST';
export const CHILDREN_UNPAGED_SUCCESS = 'CHILDREN_UNPAGED_SUCCESS';
export const CHILDREN_UNPAGED_FAILURE = 'CHILDREN_UNPAGED_FAILURE';

export const CHILDREN_SEARCH_REQUEST = 'CHILDREN_SEARCH_REQUEST';
export const CHILDREN_SEARCH_SUCCESS = 'CHILDREN_SEARCH_SUCCESS';
export const CHILDREN_SEARCH_FAILURE = 'CHILDREN_SEARCH_FAILURE';

export const CHILD_FETCH_REQUEST = 'CHILD_GET_REQUEST';
export const CHILD_FETCH_SUCCESS = 'CHILD_GET_SUCCESS';
export const CHILD_FETCH_FAILURE = 'CHILD_GET_FAILURE';

export const CHILD_CREATE_REQUEST = 'CHILD_CREATE_REQUEST';
export const CHILD_CREATE_SUCCESS = 'CHILD_CREATE_SUCCESS';
export const CHILD_CREATE_FAILURE = 'CHILD_CREATE_FAILURE';

export const CHILD_UPDATE_REQUEST = 'CHILD_UPDATE_REQUEST';
export const CHILD_UPDATE_SUCCESS = 'CHILD_UPDATE_SUCCESS';
export const CHILD_UPDATE_FAILURE = 'CHILD_UPDATE_FAILURE';

export const CHILD_MEDICAL_INFORMATION_FETCH_REQUEST = 'CHILD_MEDICAL_INFORMATION_FETCH_REQUEST';
export const CHILD_MEDICAL_INFORMATION_FETCH_SUCCESS = 'CHILD_MEDICAL_INFORMATION_FETCH_SUCCESS';
export const CHILD_MEDICAL_INFORMATION_FETCH_FAILURE = 'CHILD_MEDICAL_INFORMATION_FETCH_FAILURE';

export const CHILD_MEDICAL_INFORMATION_UPDATE_REQUEST = 'CHILD_MEDICAL_INFORMATION_UPDATE_REQUEST';
export const CHILD_MEDICAL_INFORMATION_UPDATE_SUCCESS = 'CHILD_MEDICAL_INFORMATION_UPDATE_SUCCESS';
export const CHILD_MEDICAL_INFORMATION_UPDATE_FAILURE = 'CHILD_MEDICAL_INFORMATION_UPDATE_FAILURE';

export const CHILD_BADGE_REQUEST = 'CHILD_BADGE_REQUEST';
export const CHILD_BADGE_SUCCESS = 'CHILD_BADGE_SUCCESS';
export const CHILD_BADGE_FAILURE = 'CHILD_BADGE_FAILURE';

export const loadChildren = ({ parentId, ...options }) => ({
	[CALL_API]: {
		types: [CHILDREN_REQUEST, CHILDREN_SUCCESS, CHILDREN_FAILURE],
		endpoint: 'api/children',
		request: { parentId, ...options },
		schema: Schemas.CHILD_ARRAY
	},
	parentId
});

export const loadChildrenUnpaged = ({ parentId, ...options }) => ({
	[CALL_API]: {
		types: [CHILDREN_UNPAGED_REQUEST, CHILDREN_UNPAGED_SUCCESS, CHILDREN_UNPAGED_FAILURE],
		endpoint: 'api/children/unpaged',
		request: { parentId, ...options },
		schema: Schemas.CHILD_ARRAY
	},
	parentId
});

export const loadChildrenBySearchTerm = ({ name, ...options }) => ({
	[CALL_API]: {
		types: [CHILDREN_SEARCH_REQUEST, CHILDREN_SEARCH_SUCCESS, CHILDREN_SEARCH_FAILURE],
		endpoint: 'api/children/search',
		request: { name, ...options },
		schema: Schemas.CHILD_ARRAY
	},
	searchTerm: name || ''
});

export const fetchChild = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [CHILD_FETCH_REQUEST, CHILD_FETCH_SUCCESS, CHILD_FETCH_FAILURE],
		endpoint: `api/children/${id}`,
		schema: Schemas.CHILD,
		onSuccessEvent
	}
});

export const createChild = (child, history) => ({
	[CALL_API]: {
		types: [CHILD_CREATE_REQUEST, CHILD_CREATE_SUCCESS, CHILD_CREATE_FAILURE],
		endpoint: 'api/children',
		method: 'POST',
		request: clearTimeFromDateOfBirth(child),
		schema: Schemas.CHILD,
		form: 'child',
		transition: {
			history,
			successPath: (response) => {
				const { id, parentId } = response.entities.children[response.result];
				return `/parents/${parentId}/children/${id}`;
			}
		}
	}
});

export const updateChild = (id, child) => ({
	[CALL_API]: {
		types: [CHILD_UPDATE_REQUEST, CHILD_UPDATE_SUCCESS, CHILD_UPDATE_FAILURE],
		endpoint: `api/children/${id}`,
		method: 'PUT',
		request: clearTimeFromDateOfBirth(child),
		schema: Schemas.CHILD,
		form: 'child'
	}
});

const clearTimeFromDateOfBirth = (child) =>
{
	const dateOfBirth = child.dateOfBirth;
	if (dateOfBirth) {
		child.dateOfBirth = moment(dateOfBirth).format('YYYY-MM-DD');
	}
	return child;
}

export const fetchChildMedicalInformation = (childId) => ({
	[CALL_API]: {
		types: [CHILD_MEDICAL_INFORMATION_FETCH_REQUEST, CHILD_MEDICAL_INFORMATION_FETCH_SUCCESS, CHILD_MEDICAL_INFORMATION_FETCH_FAILURE],
		endpoint: `api/childMedicalInformations/${childId}`,
		method: 'GET',
		form: 'customForm',
		schema: Schemas.MEDICAL_INFORMATION
	}
});

export const updateChildMedicalInformation = (childId, childMedicalInformation) => ({
	[CALL_API]: {
		types: [CHILD_MEDICAL_INFORMATION_UPDATE_REQUEST, CHILD_MEDICAL_INFORMATION_UPDATE_SUCCESS, CHILD_MEDICAL_INFORMATION_UPDATE_FAILURE],
		endpoint: `api/childMedicalInformations/${childId}`,
		method: 'PUT',
		request: childMedicalInformation,
		form: 'customForm',
		schema: Schemas.MEDICAL_INFORMATION
	}
});

export const getBadge = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [CHILD_BADGE_REQUEST, CHILD_BADGE_SUCCESS, CHILD_BADGE_FAILURE],
		endpoint: `api/children/${id}/badge`,
		onSuccessEvent
	}
});